import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { UserService } from '../user/user.service';

@Injectable({
  providedIn: 'root',
})
export class PositionService {
  constructor(private _userService: UserService) {}

  get hasHousekeepingAttendant$() {
    return this._userService.user$.pipe(
      map((user) => {
        const hasDeptFilters = user.hasDepartmentFilters;
        const hasPositionCode = user.deptFilterList.some(
          (filter) => filter.stdposcd === 'HKATTD',
        );
        return !hasDeptFilters || hasPositionCode;
      }),
    );
  }
}
